import { AppPagePaths } from "App/routes/paths";

import { liveOpsPathResources } from "./Pages/liveOpsPaths";
import { taskPathResources } from "./Pages/TasksPage/Pages/taskPaths";

export function useLiveOpsPathing() {
    return {
        tasksBasePath: `${AppPagePaths.liveOps}/${liveOpsPathResources.tasks}/${taskPathResources.upcoming}`,
        recentTasksBasePath: `${AppPagePaths.liveOps}/${liveOpsPathResources.tasks}/${taskPathResources.past}`,
        agentsBasePath: `${AppPagePaths.liveOps}/${liveOpsPathResources.agents}`,
        recentActivityBasePath: `${AppPagePaths.liveOps}/${liveOpsPathResources.recentActivity}`,
        queuesBasePath: `${AppPagePaths.liveOps}/${liveOpsPathResources.queues}`,
    };
}
